if (!customElements.get('goes-well-with-item')) {
  customElements.define(
    'goes-well-with-item',
    class GoesWellWithItem extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.select = this.querySelector('[data-variant-select]');
        this.priceEl = this.querySelector('[data-price]');
        this.addButton = this.querySelector('[data-add]');
        this.imageEl = this.querySelector('.goes-well-with__image');

        this.select?.addEventListener('change', () => this.onVariantChange());
      }

      onVariantChange() {
        const option = this.select?.selectedOptions[0];
        if (!option) return;

        if (this.priceEl && option.dataset.price) {
          this.priceEl.textContent = option.dataset.price;
        }

        const available = option.dataset.available === 'true';
        this.addButton?.toggleAttribute('disabled', !available);

        if (this.imageEl && option.dataset.image) {
          this.imageEl.src = option.dataset.image;
          this.imageEl.srcset = '';
        }
      }
    }
  );
}
